export function getTimezone() {
  const date = new Date().getTimezoneOffset();
  const timezone = -date;
  return timezone / 60;
}
